import useSWRImmutable from 'swr/immutable';
import type { CurrencyCode } from '@/helpers/currency';
import { fetcherSS } from '@/modules/api';
import { useGetCommonStore } from '@/store';

export interface LimitAccount {
  currency: CurrencyCode;
  amountCents: number;
  currentValueAmountCents: number;
  activeUntil: string;
}

export enum UserLimitStatus {
  Active = 'active',
  Confirmed = 'confirmed',
  Unconfirmed = 'unconfirmed',
  UnconfirmedDisable = 'unconfirmed_disable',
  ConfirmedDisable = 'confirmed_disable',
}

export type LimitPeriod = 'day' | 'week' | 'month';

export enum LimitType {
  Deposit = 'deposit',
  Loss = 'loss',
  CoolingOff = 'coolingoff',
  SelfExclusion = 'selfexclusion',
  Wager = 'wager',
}

export interface Limit {
  period: LimitPeriod;
  status: UserLimitStatus;
  disableAt: string | null;
  confirmUntil: string | null;
  parent_type: 'accounts';
  strategy: 'accounts';
  created_at: string;
  id: number;
  type: LimitType;
  accounts: LimitAccount[];
}

export const useUserLimits = () => {
  const useCommonStore = useGetCommonStore();
  const userId = useCommonStore.use.user()?.id;

  const {
    data = [],
    error,
    isLoading,
    mutate,
  } = useSWRImmutable<Limit[]>(userId ? `/user_limits/${userId}` : null, () =>
    fetcherSS('/user_limits')
  );

  return {
    data,
    error,
    isLoading,
    mutate,
  };
};
